import React, { useState, useEffect } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Municipality } from '@/lib/data';

interface CountySelectorProps {
  municipalities: Municipality[];
  onCountySelect: (county: string | null) => void;
  /** Overstyr fylkeslisten – brukes f.eks. på kart der vi vil ha fylker fra data */
  countyList?: string[];
  /** Valgt fylke for kontrollert modus */
  value?: string | null;
  /** Ekstra className for dropdown – bruk f.eks. z-[1000] på kart for å vise over Leaflet */
  selectContentClassName?: string;
}

// Statisk liste over norske fylker per 2023
const NORWEGIAN_COUNTIES = [
  'Agder',
  'Innlandet',
  'Møre og Romsdal',
  'Nordland',
  'Oslo',
  'Rogaland',
  'Troms og Finnmark',
  'Trøndelag',
  'Vestfold og Telemark',
  'Vestland',
  'Viken'
];

const CountySelector: React.FC<CountySelectorProps> = ({ municipalities, onCountySelect, countyList, value, selectContentClassName }) => {
  const counties = countyList ?? NORWEGIAN_COUNTIES;
  const handleCountyChange = (value: string) => {
    if (value === 'all') {
      onCountySelect(null);
    } else {
      onCountySelect(value);
    }
  };
  
  return (
    <div className="w-[200px] shrink-0">
      <Select onValueChange={handleCountyChange} value={value ?? 'all'} defaultValue="all">
        <SelectTrigger className="w-full bg-white border-slate-200">
          <SelectValue placeholder="Velg fylke" />
        </SelectTrigger>
        <SelectContent className={selectContentClassName}>
          <SelectItem value="all">Alle fylker</SelectItem>
          {counties.map(county => (
            <SelectItem key={county} value={county}>
              {county}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CountySelector; 